<template>
  <div class="versand-container">

    <div class="versand-header">
      <template v-if="canShipToday">
        <div class="h2">{{ $translate('Servershop5::Template.newDeldeliveryHeader') }}</div>
      </template>
      <template v-else>
        <div class="h2">{{ $translate('Servershop5::Template.newDeldeliveryHeaderNoShip') }}</div>
      </template>

    </div>

    <!-- Fortschrittsbalken für den Tagesverlauf -->
    <template v-if="isTodayIgnored || canShipToday == false">
      <template v-if="isTodayIgnored">
        <div v-html="$translate('Servershop5::Template.newDelnoDeliveryText')"></div>
      </template>
      <template v-else>
        <div v-html="$translate('Servershop5::Template.newDelnoDeliveryTextTimeIsOver')"></div>
      </template>

    </template>
    <template v-else>
      <div class="progress-container">
        <div class="progress-bar" @mouseover="showTimeMarker = true" @mouseleave="startTimerHideMarker()">
          <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>

          <!-- Markierungen für Versanddeadlines -->
          <div
              v-for="(option, index) in deadlineMarkers"
              :key="'marker-' + index"
              class="deadline-marker"
              :style="{ left: calculateDeadlinePosition(option.endtime) + '%' }"
          >
            <div class="deadline-dot" :class="{ 'expired': isDeadlineExpired(option.endtime) }"></div>
            <div class="deadline-label">{{ option.endtime }}</div>
            <div class="deadline-tooltip" :class="{ 'align-right': calculateDeadlinePosition(option.endtime) > 75 }">
              <div class="tooltip-title">{{ option.parcelname }}</div>
              <div class="tooltip-deadline">{{ $translate('Servershop5::Template.newDeldeliveryDeadline') }} {{ option.endtime }} {{ $translate('Servershop5::Template.newDeldeliveryTimeName') }}</div>
              <div v-if="!isDeadlineExpired(option.endtime)" class="tooltip-status available">
                {{ $translate('Servershop5::Template.newDeldeliveryToday') }}
                <div class="tooltip-remaining">{{ $translate('Servershop5::Template.newDeldeliveryRemainingTime') }} {{ getTimeRemaining(option.endtime) }}</div>
              </div>
              <div v-else class="tooltip-status expired">
                <span class="tooltip-icon">✗</span> {{ $translate('Servershop5::Template.newDeldeliveryDeadlineOver') }}
              </div>
              <div class="tooltip-shipping-options">
                <div class="tooltip-subtitle">{{ $translate('Servershop5::Template.newDeldeliveryAvailableOptions') }}</div>
                <div
                    v-for="(shippingOption, idx) in getAvailableShippingOptionsForDeadline(option.endtime)"
                    :key="'option-' + idx"
                    class="tooltip-shipping-option"
                >
                  {{ shippingOption.parcelname }}
                </div>
                <div v-if="getAvailableShippingOptionsForDeadline(option.endtime).length === 0" class="tooltip-no-options">
                  {{ $translate('Servershop5::Template.newDeldeliveryNoParcelsAvail') }}
                </div>
              </div>
            </div>
          </div>

          <div class="current-time-marker" :class="{ 'visible': showTimeMarker }" :style="{ left: progressPercentage + '%' }">
            <div class="marker-dot"></div>
            <div class="marker-label">{{ formattedCurrentTime }}</div>
          </div>
        </div>
        <div class="progress-time">
          <span class="start-time">{{ startTime }} {{ $translate('Servershop5::Template.newDeldeliveryTimeName') }}</span>
          <span class="end-time">{{ endTime }} {{ $translate('Servershop5::Template.newDeldeliveryTimeName') }}</span>
        </div>
      </div>
      <div class="position-relative">
        <div
            v-for="(option, index) in configuredShippingOptions"
            :key="index"
            v-if="showOption(option)"
            class="shipping-option"
            v-tooltip
            data-toggle="tooltip"
            data-placement="top"
            :title="getOptionTooltip(option)"
            @click="goToLink()"
        >

          <div class="option-name">
            <div class="option-logo d-inline-block mr-2" v-if="option.logourl">
              <img :src="option.logourl" :alt="option.parcelname">
            </div>
            {{ option.parcelname }}
          </div>
          <div class="deadline">
            {{ option.endtime }} {{ $translate('Servershop5::Template.newDeldeliveryTimeName') }}
          </div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
import TranslationService from "../services/TranslationService";

export default {
  name: 'ShippingTimer',

  props: {
    title: {
      type: String,
      default: 'Versand noch heute?'
    },
    timeLabel: {
      type: String,
      default: 'Aktuelle Zeit'
    },
    options: {
      type: Array,
      default: null
    },
    startTime: {
      type: String,
      default: '08:00'
    },
    endTime: {
      type: String,
      default: '18:00'
    },
    settings: {
      type: Array,
      default:[]
    },
    showAllOptions: {
      type: Boolean,
      default: false
    },
    url:
    {
      type: String,
      default:""
    }
  },

  data() {
    return {
      todayNoTimer:false,
      currentTime: new Date(),
      showTimeMarker: true,
      markerTimer: null,
      defaultShippingOptions:
      [
        {
          id: "1",
          parcelname: "DHL Express",
          logourl: "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/timericons/dhl-mini.png",
          endtime: "15:00"
        },
        {
          id: "2",
          parcelname: "UPS Standard",
          logourl: "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/timericons/ups-mini.png",
          endtime: "16:00"
        },
        {
          id: "3",
          parcelname: "UPS Express",
          logourl: "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/timericons/ups-mini.png",
          endtime: "16:00"
        }
      ],
      timer: null,
      serverShippingOptions: []
    };
  },

  computed: {
    canShipToday() {
      const now = new Date()

      return this.options.some(profile => {
        const [hours, minutes] = profile.endtime.split(':')
        const cutoff = new Date()
        cutoff.setHours(parseInt(hours), parseInt(minutes), 0, 0)

        return now < cutoff
      })
    },
    isTodayIgnored() {
      if (!this.settings || this.settings.length === 0) {
        return false;
      }

      const setting = this.settings[0]; // wenn du mehrere hast, ggf. anpassen
      const ignoredays = setting.ignoredays || [];
      const ignoresaturday = setting.ignoresaturday === "1";
      const ignoresunday = setting.ignoresunday === "1";

      const today = this.currentTime;
      const dayOfWeek = today.getDay(); // 0 = Sonntag, 6 = Samstag
      const todayString = today.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });

      // Prüfen ob Datum in ignoredays enthalten ist
      if (ignoredays.includes(todayString)) {
        return true;
      }

      // Prüfen ob Samstag oder Sonntag und entsprechend ignorieren
      if (dayOfWeek === 6 && ignoresaturday) {
        return true;
      }

      if (dayOfWeek === 0 && ignoresunday) {
        return true;
      }

      return false;
    },



    formattedCurrentTime() {
      const hours = this.currentTime.getHours().toString().padStart(2, '0');
      const minutes = this.currentTime.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },

    configuredShippingOptions() {
      // Priorität: 1. props.options, 2. serverShippingOptions, 3. defaultShippingOptions
      if (this.options) {


        this.options.sort((a, b) => {
          return a.endtime.localeCompare(b.endtime);
        });

        return this.options;
      } else if (this.serverShippingOptions && this.serverShippingOptions.length > 0) {
        return this.serverShippingOptions;
      } else {
        return this.defaultShippingOptions;
      }
    },

    progressPercentage() {
      // Berechnung des Tagesfortschritts als Prozentsatz
      const now = this.currentTime;
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();
      const currentTimeInMinutes = currentHours * 60 + currentMinutes;

      const [startHours, startMinutes] = this.startTime.split(':').map(Number);
      const startTimeInMinutes = startHours * 60 + startMinutes;

      const [endHours, endMinutes] = this.endTime.split(':').map(Number);
      const endTimeInMinutes = endHours * 60 + endMinutes;

      // Berechnung wie weit der Tag fortgeschritten ist (zwischen Start- und Endzeit)
      const totalDayMinutes = endTimeInMinutes - startTimeInMinutes;
      const elapsedMinutes = Math.max(0, currentTimeInMinutes - startTimeInMinutes);
      const percentage = Math.min(100, Math.max(0, (elapsedMinutes / totalDayMinutes) * 100));

      return percentage;
    },

    deadlineMarkers() {
      // Filtert Optionen mit gültigem endtime-Wert für den Fortschrittsbalken
      return this.configuredShippingOptions
          .filter(option => option.endtime)
          .sort((a, b) => {
            // Sortieren nach endtime Zeit (aufsteigend)
            const timeA = a.endtime.split(':').map(Number);
            const timeB = b.endtime.split(':').map(Number);

            const minutesA = timeA[0] * 60 + timeA[1];
            const minutesB = timeB[0] * 60 + timeB[1];

            return minutesA - minutesB;
          });
    }
  },

  methods: {
    goToLink()
    {
      if(this.url !='')
      {
        window.open(this.url, '_blank');
      }
    },
    updateCurrentTime() {
      this.currentTime = new Date();
      // Verfügbarkeit der Versandoptionen prüfen und loggen
      this.configuredShippingOptions.forEach(option => {
          const isAvailable = this.isOptionAvailable(option);

      });
    },

    startTimerHideMarker() {
      // Timer für das Ausblenden der Zeitmarkierung starten
      if (this.markerTimer) {
        clearTimeout(this.markerTimer);
      }

      this.markerTimer = setTimeout(() => {
        this.showTimeMarker = false;
      }, 3000);
    },

    isOptionAvailable(option) {
      const now = this.currentTime;
      const [deadlineHours, deadlineMinutes] = option.endtime.split(':').map(Number);

      const deadlineTime = new Date();
      deadlineTime.setHours(deadlineHours, deadlineMinutes, 0, 0);

      return now < deadlineTime;
    },

    showOption(option) {
      // Zeigt nur verfügbare Optionen oder alle, wenn showAllOptions aktiviert ist
      return this.showAllOptions || this.isOptionAvailable(option);
    },

    calculateDeadlinePosition(deadline) {
      // Berechnet die Position der Deadline-Markierung auf dem Fortschrittsbalken
      const [deadlineHours, deadlineMinutes] = deadline.split(':').map(Number);
      const deadlineInMinutes = deadlineHours * 60 + deadlineMinutes;

      const [startHours, startMinutes] = this.startTime.split(':').map(Number);
      const startTimeInMinutes = startHours * 60 + startMinutes;

      const [endHours, endMinutes] = this.endTime.split(':').map(Number);
      const endTimeInMinutes = endHours * 60 + endMinutes;

      const totalDayMinutes = endTimeInMinutes - startTimeInMinutes;
      const elapsedMinutes = Math.max(0, deadlineInMinutes - startTimeInMinutes);

      return Math.min(100, Math.max(0, (elapsedMinutes / totalDayMinutes) * 100));
    },

    isDeadlineExpired(deadline) {
      // Prüft, ob eine Deadline bereits abgelaufen ist
      const now = this.currentTime;
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      const [deadlineHours, deadlineMinutes] = deadline.split(':').map(Number);

      return (currentHours > deadlineHours) ||
          (currentHours === deadlineHours && currentMinutes >= deadlineMinutes);
    },

    getOptionTooltip(option) {

      const isAvailable = this.isOptionAvailable(option);
      const timeRemaining = this.getTimeRemaining(option.endtime);

      if (isAvailable) {
        return TranslationService.translate("Servershop5::Template.newDeldeliveryHoverText",{ "parcelname":option.parcelname,"endtime":option.endtime,"remaining":timeRemaining })
      } else {
        return TranslationService.translate("Servershop5::Template.newDeldeliveryHoverTextDeadline",{ "parcelname":option.parcelname,"endtime":option.endtime })
      }
    },

    getTimeRemaining(deadline) {
      const now = this.currentTime;
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      const [deadlineHours, deadlineMinutes] = deadline.split(':').map(Number);

      let hoursRemaining = deadlineHours - currentHours;
      let minutesRemaining = deadlineMinutes - currentMinutes;

      if (minutesRemaining < 0) {
        hoursRemaining -= 1;
        minutesRemaining += 60;
      }

      if (hoursRemaining < 0) {
        return TranslationService.translate("Servershop5::Template.newDeldeliveryNoMinutesLeft");
      }

      let result = "";
      if (hoursRemaining > 0) {
        result += hoursRemaining + TranslationService.translate("Servershop5::Template.newDeldeliveryHour") + (hoursRemaining > 1 ? TranslationService.translate("Servershop5::Template.newDeldeliveryHourEnde") : "");
      }

      if (minutesRemaining > 0) {
        if (result.length > 0) result +=  TranslationService.translate("Servershop5::Template.newDeldeliveryMinutesAndHours") ;
        result += minutesRemaining + TranslationService.translate("Servershop5::Template.newDeldeliveryMinute") + (minutesRemaining > 1 ? TranslationService.translate("Servershop5::Template.newDeldeliveryMinuteEnde") : "");
      }

      return result || TranslationService.translate("Servershop5::Template.newDeldeliveryLessThen1Minute");
    },

    startTimer() {

      // Timer aktualisiert die Zeit jede Minute
      this.timer = setInterval(() => {
        this.updateCurrentTime();
      }, 60000);

      // Initiale Aktualisierung
      this.updateCurrentTime();

      // Zeitmarkierung nach 3 Sekunden ausblenden
      this.startTimerHideMarker();
    },

    /**
     * Lädt die Versandoptionen vom Laravel-Backend
     */
    loadShippingOptions() {


      // Wenn Axios oder eine andere HTTP-Bibliothek verwendet wird
      /*
      if (window.axios) {
        axios.get('/api/shipping-options')
            .then(response => {
              if (response.data && Array.isArray(response.data)) {
                this.serverShippingOptions = response.data;
                console.log('Versandtimer: Versandoptionen erfolgreich geladen', this.serverShippingOptions);
              }
            })
            .catch(error => {
              console.error('Versandtimer: Fehler beim Laden der Versandoptionen', error);
            });
      } else {
        console.warn('Versandtimer: Axios nicht verfügbar, verwende Standard-Optionen');
      }

       */
    },

    getAvailableShippingOptionsForDeadline(deadline) {
      // Finde alle Versandoptionen mit der gleichen Deadline
      return this.configuredShippingOptions.filter(option =>
          option.endtime === deadline &&
          !this.isDeadlineExpired(deadline)
      );
    }
  },

  created() {
    // Wenn Optionen nicht als Props übergeben wurden, versuchen wir sie vom Server zu laden
    if (!this.options) {
      this.loadShippingOptions();
    }
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    // Timer bereinigen
    if (this.timer) {
      clearInterval(this.timer);
    }

    if (this.markerTimer) {
      clearTimeout(this.markerTimer);
    }
  }
};
</script>

